export class SubscriptionPeriod {
  public Monthly = 'Monthly';
  public Quarterly = 'Quarterly';
  public Yearly = 'Yearly';
}
